import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import { UserRole } from '../../types/user';
import { BookingHistory } from './BookingHistory';
import { IntervieweeBookings } from './IntervieweeBookings';
import { InterviewerBookings } from './InterviewerBookings';

function BookingsHubStrip() {
  const { userRole } = useAuth();
  const { t } = useTranslation();

  return (
    <div className="border-b border-stitch-border bg-gradient-to-r from-stitch-primary-soft via-stitch-surface to-stitch-accent-soft">
      <div className="mx-auto flex max-w-7xl flex-col gap-4 px-4 py-8 sm:flex-row sm:items-center sm:justify-between sm:px-6 lg:px-8">
        <div>
          <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-stitch-primary">
            <span className="material-symbols-outlined text-base">event_note</span>
            {t('bookings.hubBadge', 'Bookings hub')}
          </p>
          <h1 className="mt-2 text-2xl font-bold text-stitch-fg md:text-3xl">{t('bookings.hubTitle', 'Your sessions')}</h1>
          <p className="mt-1 text-sm text-stitch-muted">{t('bookings.hubSubtitle', 'Filter, confirm, and join calls from one place.')}</p>
        </div>
        <div className="flex flex-wrap gap-2">
          <Link
            to="/interviewers"
            className="inline-flex items-center gap-2 rounded-stitch-lg border border-stitch-border bg-stitch-surface px-4 py-2 text-sm font-semibold text-stitch-fg shadow-stitch-card hover:bg-stitch-surface-2"
          >
            <span className="material-symbols-outlined text-lg">person_search</span>
            {t('navigation.experts', 'Find Experts')}
          </Link>
          {userRole === UserRole.Interviewer && (
            <Link
              to="/time-slots"
              className="inline-flex items-center gap-2 rounded-stitch-lg bg-stitch-primary px-4 py-2 text-sm font-semibold text-white shadow-md shadow-stitch-primary/25 hover:bg-stitch-primary-hover"
            >
              <span className="material-symbols-outlined text-lg">schedule</span>
              {t('timeSlots.manage', 'Time slots')}
            </Link>
          )}
          <Link
            to="/interview-training"
            className="inline-flex items-center gap-2 rounded-stitch-lg border border-stitch-border bg-stitch-surface px-4 py-2 text-sm font-semibold text-stitch-fg shadow-stitch-card hover:bg-stitch-surface-2"
          >
            <span className="material-symbols-outlined text-lg">smart_toy</span>
            {t('bookings.linkAiPractice', 'AI practice')}
          </Link>
        </div>
      </div>
    </div>
  );
}

/**
 * Single entry for all booking views; picks the right experience by role.
 */
export function Bookings() {
  const { userRole } = useAuth();

  const content =
    userRole === UserRole.Interviewer ? (
      <InterviewerBookings />
    ) : userRole === UserRole.Interviewee ? (
      <IntervieweeBookings />
    ) : (
      <BookingHistory />
    );

  return (
    <div className="min-h-screen bg-stitch-canvas">
      <BookingsHubStrip />
      {content}
    </div>
  );
}
